"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.locationSaga = void 0;
const effects_1 = require("redux-saga/effects");
const connected_react_router_1 = require("connected-react-router");
const actions_1 = require("../gateway/actions");
function* locationSaga() {
    yield (0, effects_1.takeEvery)(connected_react_router_1.LOCATION_CHANGE, handleLocationChange);
}
exports.locationSaga = locationSaga;
function* handleLocationChange(_action) {
    const { query } = yield (0, effects_1.select)(connected_react_router_1.getLocation);
    const { network, gateway, transactionId, transactionStatus } = query;
    if (transactionId && transactionStatus && network && gateway) {
        const queryParams = new URLSearchParams(query);
        const params = ['transactionId', 'transactionStatus', 'network', 'gateway'];
        params.forEach(param => queryParams.delete(param));
        yield (0, effects_1.put)((0, connected_react_router_1.replace)(`${location.pathname}?${queryParams.toString()}`));
        yield (0, effects_1.put)((0, actions_1.manaFiatGatewayPurchaseCompleted)(network, gateway, transactionId, transactionStatus));
    }
}
//# sourceMappingURL=sagas.js.map